export enum SearchInputVariant {
  DEFAULT = 'default',
  COMPACT_DEFAULT = 'CompactDefault',
  GLOBAL_SEARCH = 'GlobalSearch',
}
